import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { queryFlowCopyMan } from '@/api/dashboard/waitreadApi.js';
import { updateIsRead } from '@/services/flow';
import { View } from '@antv/data-set';
export default {
  data: function data() {
    var columns = [{
      title: '标题',
      dataIndex: 'formName',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 90
    }, {
      title: '申请人',
      dataIndex: 'startUserName',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 40
    }, {
      title: '类型',
      dataIndex: 'cateName',
      ellipsis: true,
      align: 'center',
      width: 20
    }, {
      title: '接收时间',
      dataIndex: 'createTime',
      ellipsis: true,
      align: 'center',
      width: 50
    }, {
      title: '办理状态',
      dataIndex: 'isRead',
      align: 'center',
      width: 15,
      scopedSlots: {
        customRender: 'isRead'
      }
    }, {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 15,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      // pagination: {
      //     total: 0,
      //     defaultPageSize: 10,
      //     showTotal: total => `共 ${total} 条数据`,
      //     showSizeChanger: true,
      //     pageSizeOptions: ['10', '15', '20'],
      //     onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize)
      // },
      pagination: this.$hdk.page(),
      expand: false,
      formState: {
        formName: '',
        serialNumber: '',
        type: undefined,
        node: '',
        status: undefined,
        time: [],
        isRead: undefined,
        startDate: '',
        endDate: ''
      },
      text: '',
      columns: columns,
      list: []
    };
  },
  methods: {
    search: function search() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getList();
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    getList: function getList(options) {
      var _this = this;
      var pagination = this.pagination,
        formState = this.formState,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (this.formState.time.length > 0) {
        this.formState.startDate = this.formState.time[0];
        this.formState.endDate = this.formState.time[1];
      } else {
        this.formState.startDate = null;
        this.formState.endDate = null;
      }
      if (!pager.formState) {
        pager.formState = formState;
      }
      queryFlowCopyMan(pager.current, pager.pageSize, pager.formState).then(function (res) {
        _this.list = res.data.data.rows;
        _.assign(pagination, {
          total: res.data.data.total,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(formState, pager.formState);
      }).finally(function () {
        _this.loading = false;
      });
    },
    /**
     *切换分页时调用
     */
    change: function change(pagination) {
      this.getList({
        current: pagination.current,
        pageSize: pagination.pageSize,
        formState: this.formState
      });
    },
    view: function view(row) {
      updateIsRead({
        copyId: row.copyId
      }).then(function (res) {});
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: row.processInstanceId
        }
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getList();
  }
};